import React from 'react';
import { Chip } from 'shared/ui/Chip';
import { useConfigInputs, useVendorCtx } from 'shared/state/configContexts';

/** DELIVERY · TERM · FABRIC · PROTOCOL · SERVICE · COMPRESSION — the decisions a
 *  reader wants at a glance without opening a section. CONF-218 added the protocol
 *  and one compression chip per enabled storage set, and a title on every chip
 *  naming the decision, since the row is too terse to explain itself. The
 *  service-label lookup duplicates the one in useSubscriptionSection; importing a
 *  section hook into shell chrome would drag its ability checks along, so the
 *  small duplication is accepted here. */
export function RibbonChips() {
  const { config } = useConfigInputs();
  const { vendor } = useVendorCtx();
  const services = (vendor.capabilities.serviceOptions ?? []) as Array<{ key: string; label: string }>;
  const serviceLabel = services.find((s) => s.key === config.serviceOption)?.label ?? String(config.serviceOption ?? '');

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Chip title="Delivery quarter">{String(config.quarter ?? '')}</Chip>
      <Chip title="Subscription term">{`${config.subscriptionMonths ?? 0} mo`}</Chip>
      <Chip title="Network option">{String(config.interfaceOption ?? '')}</Chip>
      {config.networkProtocol && <Chip title="Network protocol">{String(config.networkProtocol)}</Chip>}
      <Chip title="Service level">{serviceLabel}</Chip>
      {config.afaEnabled && <Chip title="Flash set data compressibility">{`Flash ${config.afaCompressionRatio ?? 1}:1`}</Chip>}
      {config.hybridEnabled && <Chip title="Capacity set data compressibility">{`Mixed ${config.hybridCompressionRatio ?? 1}:1`}</Chip>}
    </div>
  );
}
